// utils/modalComponentStore.js
let _mainModalComponent = null;
let _subModalComponent = null;

export const modalComponentStore = {
  getMainComponent: () => _mainModalComponent,
  setMainComponent: (component) => {
    _mainModalComponent = component;
  },
  getSubComponent: () => _subModalComponent,
  setSubComponent: (component) => {
    _subModalComponent = component;
  }
};
